<template>
  <div>
    <!-- Story Modal -->
    <b-toast
        id="story-sidebar-toast-skip"
        toast-class="story-sidebar-toast-wrapper"
        body-class="story-sidebar-toast"
        :visible="showSkipToast"
        :auto-hide-delay="5000"
        :no-close-button="true"
        @hidden="showSkipToast=false"
      >
        Story skipped to end, click Argo for training options
    </b-toast>
    <b-modal
      id="story-modal"
      hide-header
      hide-footer
      size="lg"
      :modal-class="'story-modal-component'"
    >
      <div class="story-modal">
        <img v-if="Progression.storyIndex < Object.keys(storyInstructions.shop[Progression.stepIndex].story).length - 1" class="confirm-next-button-image-1" src="./assets/panel-next-button.png"/>
        <button
          v-if="Progression.storyIndex < Object.keys(storyInstructions.shop[Progression.stepIndex].story).length - 1"
          class="confirm-next-button-1"
          @click="replacePanelText"
        >
        continue
        </button>
        <button
          v-else
          class="confirm-next-button-2"
          @click="completePanelText"
        >
          <img class="confirm-next-button-image-2" src="./assets/panel-confirm-button.png"/>
        </button>
        <typewriter ref="typewriter" class="typewriter" :type-interval="1" :replace-interval="1">
          <div class="typewriter-text">
            {{storyInstructions.shop[Progression.stepIndex].story[Progression.storyIndex]}}
          </div>
        </typewriter>
        <button class="skip-button" @click="skipStoryProgress">
          skip
        </button>
      </div>
    </b-modal>
    
    <b-modal
        id="buy-boosters-modal"
        hide-header
        hide-footer
      >
        <div class="booster-modal-content">
          <p class="booster-modal-main-title">
            Buy Booster Minting Credits for {{ getEtherCostofBooster }} GLMR each
          </p>
          <p class="booster-modal-explain">
            Enter the # of booster NFT minting credits you would like to
            purchase:
          </p>
          <img
            class="booster-modal-icon"
            src="../components/assets/buy_booster_credits_icon.png"
          />
          <button
            class="booster-modal-buy-button"
            style="
              background-color: transparent;
              border-color: transparent;
              position: relative;
              display: block;
              margin-left: auto;
              margin-right: auto;
            "
            :disabled="(totalCreditsToBuy * getEtherCostofBooster) + 0.5 > getBalance"
            @click="buyBoosters"
          >
            <img
              class="booster-modal-image"
              src="../components/assets/buy_booster_credits_button.png"
            />
            <span
              :class="{
                'booster-modal-text': true,
                'grey-text': ((totalCreditsToBuy * getEtherCostofBooster) + 0.5 > getBalance),
              }"
              style="
                font-family: 'Truculenta', sans-serif;
                font-weight: 700;
              "
              >BUY CREDITS</span
            >
          </button>
          <p class="booster-modal-title">
            Booster NFT cards will NEVER be sold in the shop
          </p>
          <input
            id="toWallet"
            class="booster-modal-form"
            type="text"
            value="1"
            required
            @input="totalCreditsToBuy = $event.target.value"
          />
          <div class="booster-modal-close-button">
            <button
              block
              style="
                background-color: transparent;
                border-color: transparent;
                position: relative;
                display: block;
                margin-left: auto;
                margin-right: auto;
              "
              @click="$bvModal.hide('buy-boosters-modal')"
            >
              <span
                class="booster-modal-close"
                style="
                  font-family: 'Truculenta', sans-serif;
                  font-weight: 700;
                  font-size: 20px;
                "
                >CLOSE</span
              >
            </button>
          </div>
        </div>
      </b-modal>
    <div>
      <UniverseBalances />
      <h1 class="shop-title">MINTING SHOP</h1>
      <div v-if="isWalletConnected">
        <div class="row">
          <div class="col">
            <OwnerBalances />
          </div>
          <div class="col right-side-buttons">
            <div id="shop-info-button" class="shop-info-button"></div>
            <b-popover :show="Progression.stepIndex==3 && Progression.storyIndex==1" target="shop-info-button" triggers="hover focus manual" placement="left" container="shop-info-popover">
              <div class="shop-description">
                <p>
                  The Shop is a place to mint limited edition Zoombies Cards NFT tokens.
                  Some cards are free, some have a cost. You may also buy and
                  <router-link :to="{ name: 'CryptContent', params: { chain: currentChain }}"> open a booster card </router-link
                  >, which will mint a random booster edition NFT token.
                </p>
                <p>
                  To mint a FREE NFT Or buy a Limited edition NFT at cost, you will need
                  a Zoom Score <img
                    src="./assets/zoom_score.webp"
                    class="fastpass-popover-icon"
                  />
                  higher than the Zoom Unlock displayed on the bottom.<br />
                  Your ZOOM Score is the amount of ZOOM that has passed through your account. You don't need to HAVE that much ZOOM in your wallet at the time of purchase but, you need to HAVE HAD that much ZOOM go through your account.
                  <br /><br />
                  You will automatically see a
                  <img
                    src="./assets/fastpass.webp"
                    class="fastpass-popover-icon"
                  />
                  Fast Pass price to bypass the ZoomScore requirement and may pay 3x the
                  cost to buy immediately on non-Free cards.
                </p>
                <p>
                  Minting a FREE NFT will ALWAYS burn the amount of ZOOM displayed on
                  the back of the card to keep harmony with the ZOOM force.
                </p>

                <p>
                  The newly minted NFT will appear in
                  <router-link :to="{ name: 'CryptContent', params: { chain: currentChain }}"> Your NFT Crypt </router-link>
                  once the transaction is confirmed, 500 ZOOM tokens will burned when
                  minting.
                </p>
              </div>
            </b-popover>
            <div id="shop-info-popover"></div>
            <b-button
              id="buy-boosters-btn"
              v-b-tooltip.hover="'Earn +700 ZOOM per credit'"
              v-b-modal.buy-boosters-modal
            >
              Buy Booster NFT Credits
            </b-button>
          </div>
        </div>
      </div>

      <div v-else>
        <h2 class="centered">
          <b-button
            v-if="!isWalletConnected"
            id="connect-button"
            v-b-toggle.nav-collapse
            variant="primary"
            @click="onConnect"
          >
            Connect
          </b-button>
          your wallet to mint NFTs.
        </h2>
      </div>

      <div v-if="isLoadingShopCards" class="loading">
        <b-spinner style="width: 3rem; height: 3rem" type="grow" />
      </div>
      <div v-else>
        <div class="row sort-wrapper">
          <div class="col text-left">
            <SortDropdown @sort-by-attr="sortByAttr" />
          </div>
        </div>
      </div>
      <br />
      <div id="cards-wrapper">
        <div
          v-for="(card, i) in displayCards"
          :key="card.type_id"
          class="card-wrapper"
        >
          <OwnedCardContent
            :type_id="card.type_id"
            :name="card.name"
            :cost="card.cost"
            :cset="card.card_set"
            :edition_current="card.edition_current"
            :edition_total="card.edition_total"
            :in_store="card.in_store"
            :level="card.card_level"
            :unlock_czxp="card.unlock_czxp"
            :buy_czxp="card.buy_czxp"
            :sacrifice_czxp="card.sacrifice_czxp"
            :image="card.image"
            :card_class="card.rarity"
            :card_owned="false"
            :index="i"
            :observer="observer"
          />
          <div v-if="isWalletConnected" class="card-button-container">
            <div
              v-if="card.soldOut == 1"
              id="sold-button-wrapper"
              v-b-tooltip.hover="getSoldCardToolTipText"
            >
              <button id="sold-button" class="btn btn-danger">
                SOLD OUT
              </button>
            </div>

            <div
              v-else-if="parseInt(card.release_time * 1000) > getNowTimeStamp"
              id="unreleased-button-wrapper"
            >
              <div v-b-tooltip.hover="getBtnTooltipTextUnreleased">
                <button id="unreleased-button" class="btn btn-warning">
                  <img
                    src="./assets/lock.webp"
                    class="lock-icon"
                  />
                  {{
                    getFormattedReleasedLabel(card.id, card.release_time * 1000)
                  }}
                </button>
              </div>
            </div>

            <div
              v-else-if="!card.isOwned"
              id="buy-get-button-wrapper"
            >
              <div
                v-if="card.cost > 0"
                id="buyBtnwrapper"
                v-b-tooltip.hover="
                  buyBtnTooltipText(card.cost, card.unlock_czxp)
                "
              >
                <b-button
                  id="buy-button"
                  variant="primary"
                  @click="buyCard(card)"
                >
                  <img
                    v-if="
                      (parseFloat(getBalance) <= parseFloat(3 * card.cost) &&
                        getZoomBalance < parseInt(card.unlock_czxp)) ||
                      parseFloat(getBalance) <= card.cost
                    "
                    src="./assets/lock.webp"
                    class="lock-icon"
                  />
                  Mint for
                  {{
                    getZoomScore < parseInt(card.unlock_czxp)
                      ? (card.cost * 3).toFixed(0)
                      : card.cost
                  }}
                  <img
                    src="./assets/moonbeam_logo.png"
                    class="mr-icon"
                  />
                </b-button>
                <img
                  v-if="getZoomScore  < parseInt(card.unlock_czxp)"
                  v-b-tooltip.hover="'You are paying 3x the cost to bypass the ZoomScore requirement'"
                  src="./assets/fastpass.webp"
                  class="fastpass-icon"
                />
              </div>
              <div
                v-else-if="getZoomBalance < card.buy_czxp"
                id="getBtnwrapper"
                v-b-tooltip.hover="getBtnBlockedBurnTooltipTextContent"
              >
                <button
                  id="get-button"
                  class="btn btn-primary"
                >
                  <img
                    src="./assets/lock.webp"
                    class="lock-icon"
                  />
                  Mint for FREE
                </button>
               </div>
               <div
                v-else-if="getZoomScore < parseInt(card.unlock_czxp)"
                id="getBtnwrapper"
                v-b-tooltip.hover="'Your ZOOM score is too low to mint this card'"
              >
                <button
                  id="get-button"
                  class="btn btn-primary"
                >
                  <img
                    src="./assets/lock.webp"
                    class="lock-icon"
                  />
                  Mint for FREE
                </button>
               </div>
                <div
                v-else
                id="getBtnwrapper"
                v-b-tooltip.hover="getBtnTooltipText(card.unlock_czxp)"
              >
                <button
                  id="get-button"
                  class="btn btn-primary"
                  @click="getCardForFree(card)"
                >
                  Mint for FREE
                </button>
              </div>
            </div>

            <div
              v-else
              id="owned-button-wrapper"
              v-b-tooltip.hover="getOwnedCardToolTipText"
            >
              <button id="owned-button" class="btn btn-info">
                Already Minted
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import './assets/global.css';
import { mapGetters } from "vuex";
import debounce from "lodash/debounce";
import { BButton, BSpinner, BPopover } from "bootstrap-vue";

import OwnedCardContent from "@/components/OwnedCardContent.vue";
import UniverseBalances from "@/components/UniverseBalances.vue";
import OwnerBalances from "@/components/OwnerBalances.vue";
import SortDropdown from "@/components/SortDropdown.vue";
import dAppStates from "@/dAppStates";
import { showErrorToast } from "../util/showToast";
import { MessageBus } from "@/messageBus";
import { ethers } from "ethers";
import Typewriter from "typewriter-vue";
import Progress from './Progress.js';
import storyInstructions from "./story-instructions.json";
import { Progression } from './Progression.js'

export default {
  name: "ShopContent",
  components: {
    OwnedCardContent,
    UniverseBalances,
    OwnerBalances,
    SortDropdown,
    BButton,
    BSpinner,
    BPopover,
    Typewriter,
  },
  data() {
    return {
      buyBtnTooltipTextContent:
        "Click to mint a limited edition NFT of this card",
      buyBtnBlockedTooltipTextContent:
        "You do not have enough GLMR tokens to unlock minting",
      buyBtnFastPassTooltipTextContent:
        "Fast Pass the ZoomScore requirement and mint this NFT now",
      getBtnTooltipTextContent:
        "Click to mint a limited edition NFT at no GLMR cost",
      getBtnBlockedBurnTooltipTextContent:
        "You do not have the required ZoomBurn to mint this for FREE",
      getOwnedCardToolTipText: "You can only mint 1 card of each type",
      getSoldCardToolTipText:
        "All NFTs of this type have been minted, check markets",
      getBtnTooltipTextUnreleased:
        "This type has not been released for NFT minting yet",
      storyInstructions,
      Progression,
      showSkipToast: false,
      totalCreditsToBuy: 1,
      isBuyingBooster: false,
      isCardSorted: false,
      pageSize: 15,
      paginatedCards: [],
      sortedPaginatedCards: [],
      pageNext: 0,
      sortedPageNext: 0,
      observer: null,
      nowTimeStamp: 0,
      currentChain: "moonbase",
    };
  },
  beforeUnmount() {
    this.observer.disconnect();
    clearInterval(window.nowTimer);
  },
  created() {
    this.ProgressInstance = new Progress();
    const progress = this.ProgressInstance.getProgress();

    if (progress.hasOwnProperty('shop')) {
      Progression.stepIndex = progress.shop;
    } else {
      Progression.stepIndex = 1;
    }
    this.ProgressInstance.updateProgress({name: 'shop', value: Progression.stepIndex});

    this.observer = new IntersectionObserver(this.onElementObserved, {
      root: this.$el,
      threshold: 1.0,
    });
    this.loadMoreCards = debounce(
      () => {
        if (this.isCardSorted) {
          const newCards = this.$store.getters.getPaginatedShopCards(
            this.pageSize,
            this.sortedPageNext,
            this.isCardSorted
          );
          this.sortedPaginatedCards = [
            ...this.sortedPaginatedCards,
            ...newCards.cards,
          ];
          this.sortedPageNext = newCards.next;
        } else {
          const newCards = this.$store.getters.getPaginatedShopCards(
            this.pageSize,
            this.pageNext,
            this.isCardSorted
          );
          this.paginatedCards = [...this.paginatedCards, ...newCards.cards];
          this.pageNext = newCards.next;
        }
      },
      500,
      { leading: true }
    );
  },
  async mounted() {
    this.$root.$on('bv::popover::show', bvEventObj => {
      Progression.popOverSound.play();
    })

    this.$nextTick(() => {
      Progression.storyIndex = 0;

      const progress = this.ProgressInstance.getProgress();
      if (progress.hasOwnProperty('shop')) {
        Progression.stepIndex = progress.shop;
      } else {
        Progression.stepIndex = 1;

      }

      if (progress.shopCompleted === false) {
        Progression.popOverSound.play();
        Progression.typingSound.currentTime = 83;
        Progression.typingSound.play();
        this.$bvModal.show('story-modal');
      }
    });

    if (this.getAllShopCards.length > 0) {
      this.setStoreCard();
    }
    
    if(window.ethereum) {
      if(
        await window.ethereum.request({method: 'eth_chainId'}) == 0x504 ||
        window.location.pathname.includes('/moonbeam', 0)
        ) 
        { 
        this.currentChain =  'moonbeam';
      }
      else {
        this.currentChain =  'moonbase';
      }
    } else {
      this.currentChain =  'moonbeam';
    }
    window.nowTimer = setInterval(this.setNow, 1000);
  },
  computed: {
    dAppState() {
      return this.$store.state.dAppState;
    },
    cardCost() {
      return getZoomBalance < parseInt(card.unlock_czxp)
        ? (card.cost * 3).toFixed(3)
        : card.cost;
    },
    isWalletConnected() {
      return this.$store.state.dAppState === dAppStates.WALLET_CONNECTED;
    },
    getNowTimeStamp() {
      return this.nowTimeStamp;
    },
    displayCards() {
      return this.isCardSorted
        ? this.sortedPaginatedCards
        : this.paginatedCards;
    },
    canLoadMore() {
      if (this.isCardSorted) {
        return this.sortedPageNext !== null;
      } else {
        return this.pageNext !== null;
      }
    },
    ...mapGetters([
      "isLoadingShopCards",
      "isShopLoadingFinished",
      "getAllShopCards",
    ]),
    ...mapGetters({
      getWalletAddress: "blockChain/getWalletAddress",
      getBalance: "blockChain/getBalance",
      getZoomBalance: "blockChain/getZoomBalance",
      getZoomScore: "blockChain/getZoomScore",
      getSignedZoombiesContract: "blockChain/getSignedZoombiesContract",
      getEtherCostofBooster: "blockChain/getEtherCostofBooster",
    }),
  },
  watch: {
    getAllShopCards(newVal) {
      if (newVal.length > 0) {
        this.setStoreCard();
      }
    },
  },
  methods: {
    replacePanelText() {
      if (Progression.storyIndex < storyInstructions.shop[Progression.stepIndex].story.length - 1) {

        Progression.typingSound.currentTime = (Math.random() * 3) + 82;
        Progression.typingSound.play();

        this.$refs.typewriter.replaceText({
          from: storyInstructions.shop[Progression.stepIndex].story[Progression.storyIndex],
          to: storyInstructions.shop[Progression.stepIndex].story[Progression.storyIndex + 1],
        });
      }
      
      Progression.storyIndex++;

    },
    completePanelText() {
      this.$bvModal.hide('story-modal');

      // if (Progression.storyIndex === 4 && Progression.stepIndex === 7) {
      //   this.$bvModal.hide('sponsor-modal');
      // } 

      Progression.stepIndex++;
      this.ProgressInstance.updateProgress({name: 'shop', value: Progression.stepIndex});

      if (Progression.stepIndex > Object.keys(storyInstructions.shop).length) {
        Progression.stepIndex = Object.keys(storyInstructions.shop).length;
        this.ProgressInstance.updateProgress({name: 'shop', value: Progression.stepIndex});

        this.ProgressInstance.updateProgress({name: 'shopCompleted', value: true});
        Progression.storyIndex = 4; // placeholder value
        Progression.storyCompletedSound.play();
      } else {
        this.$bvModal.show('story-modal');
        Progression.progressStepSound.play();
        Progression.storyIndex = 0; // placeholder value
        this.ProgressInstance.updateProgress({name: 'shopCompleted', value: false});
      }
    },
    skipStoryProgress() {
      this.showSkipToast = true;

      Progression.stepIndex = Object.keys(storyInstructions.shop).length; // Specific for this page
      Progression.storyIndex = 4;

      this.completePanelText();
    },
    setStoreCard: async function () {
      const pageStart = this.isCardSorted ? this.sortedPageNext : this.pageNext;
      const newCards = this.$store.getters.getPaginatedShopCards(
        this.pageSize,
        pageStart,
        this.isCardSorted
      );

      if (this.isCardSorted) {
        this.sortedPaginatedCards = [
          ...this.sortedPaginatedCards,
          ...newCards.cards,
        ];
        this.sortedPageNext = newCards.next;
      } else {
        this.paginatedCards = [...this.paginatedCards, ...newCards.cards];
        this.pageNext = newCards.next;
      }
    },
    setNow() {
      this.nowTimeStamp = Date.now();
    },
    getBuyZoom(val) {
      //unlock * 10 * baseCost   =    val * 10 * 100000000000000
      return parseFloat(0.0000001 * 10 * val);
    },
    getFormattedReleasedLabel(id, releaseTime) {
      var timeRemaining = new Date(
        releaseTime - new Date().getTime()
      ).getTime();

      var days = Math.floor(timeRemaining / (1000 * 60 * 60 * 24));
      var hours = Math.floor(
        (timeRemaining % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
      );
      var minutes = Math.floor(
        (timeRemaining % (1000 * 60 * 60)) / (1000 * 60)
      );
      var seconds = Math.floor((timeRemaining % (1000 * 60)) / 1000);

      return days + "d " + hours + "h " + minutes + "m " + seconds + "s ";
    },
    getBtnTooltipText(unlock_czxp) {
      if (this.getZoomBalance < parseInt(unlock_czxp)) {
        return this.getBtnBlockedTooltipTextContent;
      } else {
        return this.getBtnTooltipTextContent;
      }
    },
    getCardForFree: async function (cardAttributes) {
      try {
        this.showTransactionModal();
        this.$store.dispatch("setCardAsBought", {
          cardId: cardAttributes.type_id,
          isSorted: this.isCardSorted,
        });

        let freeCost = 0;

        const result = await this.getSignedZoombiesContract.getFreeCard(
          cardAttributes.type_id,
          {
            value: freeCost,
          }
        );
        this.$store.dispatch("setIsTransactionConfirmed", true);
        await result.wait();

        if (result) {
          this.$store.dispatch("setCurrentEdition", {
            cardId: cardAttributes.type_id,
            edition: (cardAttributes.edition_current += 1),
            isSorted: this.isCardSorted,
          });
          this.$store.dispatch("blockChain/updateWalletBalances");
          this.$store.dispatch("blockChain/updateUniverseBalances");
        }
      } catch (err) {
        this.$store.dispatch("setCardAsNotBought", {
          cardId: cardAttributes.type_id,
          isSorted: this.isCardSorted,
        });

        if (error.code == 'ACTION_REJECTED') {
          showErrorToast(this, "Request cancelled");
        }
        else {
          showErrorToast(this, "Failed to mint card");
        }
      } finally {
        this.hideTransactionModal();
      }
    },
    buyCard: async function (cardAttributes) {
      try {
        this.$store.dispatch("setCardAsBought", {
          cardId: cardAttributes.id,
          isSorted: this.isCardSorted,
        });

        this.showTransactionModal();
        let cardBNValue = ethers.utils
          .parseEther(cardAttributes.cost)
          .toString();

        //Ovrerride price for Fast Pass  
        if (this.getZoomScore < cardAttributes.unlock_czxp) {
          cardBNValue = ethers.utils
            .parseEther((cardAttributes.cost * 3).toFixed(5))
            .toString();
        }

        const result = await this.getSignedZoombiesContract.buyCard(
          parseInt(cardAttributes.type_id),
          {
            value: cardBNValue.toString(),
          }
        );

        this.$store.dispatch("setIsTransactionConfirmed", true);
        await result.wait();

        if (result) {
          this.$store.dispatch("setCurrentEdition", {
            cardId: cardAttributes.id,
            edition: (cardAttributes.edition_current += 1),
            isSorted: this.isCardSorted,
          });
          this.$store.dispatch("blockChain/updateWalletBalances");
          this.$store.dispatch("blockChain/updateUniverseBalances");
        }
      } catch (err) {
        console.log(err);
        this.$store.dispatch("setCardAsNotBought", {
          cardId: cardAttributes.id,
          isSorted: this.isCardSorted,
        });
        if (err.code == "ACTION_REJECTED") {
          showErrorToast(this, "Request cancelled");
        } else {
          showErrorToast(this, "Failed to mint card");
        }
      } finally {
        this.hideTransactionModal();
      }
    },
    buyBoosters: async function () {
      try {
        this.$bvModal.hide("buy-boosters-modal");
        this.isBuyingBooster = true;

        this.showTransactionModal();

        var totalBoostersCost = ethers.utils
          .parseEther((this.getEtherCostofBooster * parseInt(this.totalCreditsToBuy)).toString())
          .toString();

        const res = await this.getSignedZoombiesContract.buyBoosterCredits(
          parseInt(this.totalCreditsToBuy),
          {
            value: totalBoostersCost,
          }
        );
        this.$store.dispatch("setIsTransactionConfirmed", true);

        await res.wait();
        this.$store.dispatch("blockChain/updateWalletBalances");
        this.$store.dispatch("blockChain/updateUniverseBalances");
      } catch (error) {
        console.error(error);
        if (error.code == 'ACTION_REJECTED') {
          showErrorToast(this, "Request cancelled");
        }
        else {
          showErrorToast(this, "Failed to mint card");
        }
      } finally {
        this.isBuyingBooster = false;
        this.hideTransactionModal();
      }
    },
    buyBtnTooltipText(cost, unlock_czxp) {
      if (
        (parseFloat(this.getBalance) <= parseFloat(3 * cost) &&
          parseInt(this.getZoomBalance) < parseInt(unlock_czxp)) ||
        parseFloat(this.getBalance) <= parseFloat(3 * cost)
      ) {
        return this.buyBtnBlockedTooltipTextContent;
      } else if (
        parseFloat(this.getBalance) > parseFloat(3 * cost) &&
        parseInt(this.getZoomBalance) < parseInt(unlock_czxp)
      ) {
        return this.buyBtnFastPassTooltipTextContent;
      } else {
        return this.buyBtnTooltipTextContent;
      }
    },
    sortByAttr: async function (param, isDescending) {
      if (!param) {
        // We cleared sort.
        // Clear all data so we start with a new page of sort
        this.isCardSorted = false;
        this.sortedPaginatedCards = [];
        this.sortedPageNext = 0;
        return;
      }

      this.sortedPaginatedCards = [];
      this.sortedPageNext = 0;
      this.isCardSorted = true;
      await this.$store.dispatch("sortCards", {
        param,
        isDescending,
      });

      const newCards = this.$store.getters.getPaginatedShopCards(
        this.pageSize,
        this.sortedPageNext,
        this.isCardSorted
      );

      this.sortedPaginatedCards = [...newCards.cards];
      this.sortedPageNext = newCards.next;
    },
    showTransactionModal() {
      this.$store.dispatch("setIsTransactionPending", true);
      this.$store.dispatch("setIsSacrificeEvent", false);
    },
    hideTransactionModal() {
      this.$store.dispatch("setIsTransactionPending", false);
      this.$store.dispatch("setIsTransactionConfirmed", false);
    },
    onConnect: function () {
      MessageBus.$emit("connect");
    },
    onElementObserved(entries) {
      entries.forEach(({ target, isIntersecting }) => {
        if (!isIntersecting) {
          return;
        }

        this.observer.unobserve(target);

        const index = parseInt(target.getAttribute("data-index"));
        // if the 10th last card scrolls into view, load more
        if (index === this.displayCards.length - 10) {
          if (this.canLoadMore) {
            this.loadMoreCards();
          }
        }
      });
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

.right-side-buttons {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 1em;
}
.shop-title {
  padding-left: 12px;
  margin-bottom: 0px;
  font-family: Truculenta; 
  font-weight: 700;
}

button {
  white-space: nowrap !important;
}

::v-deep .modal-content {
  background-color: transparent;
  border: none;
}

.modal-content {
  background-color: transparent;
}

.modal-content.booster-modal {
  background-color: transparent;
}

.booster-modal-content {
  background-image: url("../components/assets/buy_booster_credits_bg.png");
  background-color: transparent;
  background-position: center;
  background-repeat: no-repeat;
  background-size: 100%;
  width: fit-content;
  height: 750px;
}

.booster-modal-main-title {
  padding-left: 70px;
  padding-right: 70px;
  padding-top: 270px;
  font-family: "Truculenta", sans-serif;
  font-size: 24px;
  font-weight: 700;
  text-align: center;
  color: #ffffff;
}

.booster-modal-title {
  padding-left: 150px;
  padding-right: 150px;
  margin-bottom: 0px;
  font-family: "Truculenta", sans-serif;
  font-size: 16px;
  font-weight: 500;
  text-align: center;
  color: #ffffff;
  margin-bottom: 0px;
}

.booster-modal-explain {
  padding-left: 130px;
  padding-right: 130px;
  margin-bottom: 2px;
  font-family: "Truculenta", sans-serif;
  font-size: 20px;
  font-weight: 700;
  text-align: center;
  color: #00D1FF;
}

.booster-modal-close {
  font-family: "Truculenta", sans-serif;
  font-size: 15px;
  font-weight: 700;
  text-align: center;
  color: #ffffff;
}

.booster-modal-icon {
  padding-left: 160px;
  height: 55px;
  width: auto;
}

.booster-modal-form {
  transform: translate(290%, -535%);
  width: 75px;
  color: #ffffff;
  border: 1px solid #1E162F;
  border-radius: 1px;
  background-color : #1E162F;
}

.booster-modal-image {
  margin-top: 5px;
  height: 50px;
}

.booster-modal-text {
  font-size: 20px;
  color: #ffffff;
  position: absolute;
  transform: translate(-135%, 40%);
}

.grey-text {
  color: #b5b5b5;
}

.booster-modal-close {
  color: #ffffff;
  position: absolute;
}

.booster-modal-close-button {
  padding-left: 200px;
  padding-right: 200px;
  align-items: center;
  justify-content: center;
  display: flex;
  width: 100%;
  position: absolute;
  right: 5%;
}

@media screen and (max-width: 800px) {
  .booster-modal-content {
    background-image: url("../components/assets/buy_booster_credits_bg.png");
    background-color: transparent;
    background-position: center;
    background-repeat: no-repeat;
    background-size: 100%;
    width: fit-content;
    height: 500px;
  }

  .booster-modal-main-title {
    padding-left: 70px;
    padding-right: 70px;
    padding-top: 170px;
    font-family: "Truculenta", sans-serif;
    font-size: 16px;
    font-weight: 700;
    text-align: center;
    color: #ffffff;
  }

  .booster-modal-title {
    padding-left: 110px;
    padding-right: 110px;
    font-family: "Truculenta", sans-serif;
    font-size: 12px;
    font-weight: 500;
    text-align: center;
    color: #ffffff;
  }
  
  .booster-modal-explain {
    padding-left: 90px;
    padding-right: 90px;
    margin-bottom: 2px;
    font-family: "Truculenta", sans-serif;
    font-size: 15px;
    font-weight: 700;
    text-align: center;
    color: #00D1FF;
  }

  .booster-modal-close {
    font-family: "Truculenta", sans-serif;
    font-size: 15px;
    font-weight: 700;
    text-align: center;
    color: #ffffff;
  }

  .booster-modal-icon {
    padding-left: 110px;
    height: 45px;
    width: auto;
  }

  .booster-modal-form {
    transform: translate(225%, -410%);
    width: 70px;
    color: #ffffff;
    border: 1px solid #1E162F;
    border-radius: 1px;
    background-color : #1E162F;
  }

  .booster-modal-image {
    margin-top: 0px;
    height: 35px;
  }

  .booster-modal-text {
    font-size: 15px;
    color: #ffffff;
    position: absolute;
    transform: translate(-130%, 25%);
  }

  .grey-text {
    color: #b5b5b5;
  }

  .booster-modal-close {
    color: #ffffff;
    position: absolute;
  }

  .booster-modal-close-button {
    padding-left: 200px;
    padding-right: 200px;
    align-items: center;
    justify-content: center;
    display: flex;
    width: 100%;
    position: absolute;
    transform: translate(2%, -250%);
  }
}

#buy-get-button-wrapper,
#owned-button-wrapper,
#sold-button-wrapper {
  position: relative;
  text-align: center;
  width: 80%;
}

#sold-button,
#owned-button {
  color: #ffffff;
  background-image: url("./assets/red_button_400.webp");
}
#unreleased-button {
  color: #ffffff;
  background-image: url("./assets/grey_button_400.webp");
}

#get-button,
#buy-button {
  color: #130E1E;
  background-image: url("./assets/green_button_400.webp");
}

.loading {
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: center;
  margin-top: 36px;
}

.sort-wrapper {
  margin-bottom: 36px;
}

.spinner {
  width: 2em;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.1s;
}
.fade-enter,
.fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

.shop-card-item {
  display: flex;
  flex-direction: column;
  width: 260px;
}

.flex-row {
  display: flex;
  flex-flow: row wrap;
  justify-content: space-around;
}

.card-button-container {
  display: flex;
  justify-content: center;
  margin-bottom: 2rem;
}

.card-button-container button {
  font-size: 16px;
}

#cards-wrapper {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));
  place-items: center;

  button {
    background-color: transparent;
    background-size: 100% 100%;
    border: none;
    /* color: white; */
    font-family: 'Truculenta';
    font-style: normal;
    font-weight: 700;
    font-size: 18px;
    line-height: 26px;
    text-align: center;
    width: 100%;
  }
}

.shop-description {
  font-family: 'Truculenta';
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 20px;
  color: #FFFFFF;
}

#buy-boosters-btn {
  background-color: transparent;
  background-image: url("./assets/purple_button_500.webp");
  background-size: 100% 100%;
  border: none;
  
  padding: 10px 14px;
  width: 240px;

  font-family: 'Truculenta';
  font-style: normal;
  font-weight: 700;
  font-size: 20px;
  line-height: 24px;
  text-align: center;
  text-transform: uppercase;

  color: #FFFFFF;
}

.shop-info-button {
  background-color: transparent;
  background-image: url("assets/help.webp");
  background-size: contain;
  background-repeat: no-repeat;
  border: none;
  height: 35px;
  width: 35px;

  animation: float 4s ease-in-out infinite;

  &:hover {
    animation-play-state: paused;
  }
}

@keyframes float {
	0% {
		transform: translatey(0px);
	}
	50% {
		transform: translatey(-15px);
	}
	100% {
		transform: translatey(0px);
	}
}

.card-wrapper {
  display: flex;
  min-width: 0;
  flex-direction: column;
  width: 260px;
}

.load-more {
  width: 100%;
  margin-top: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.centered {
  display: flex;
  justify-content: center;
}

#connect-button {
  font-size: 20px;
  padding: 5px 10px;
  margin-right: 10px;
}

.booster-modal-footer {
  display: flex;
  align-items: flex-end;

  button {
    margin-left: 16px;
  }
}

.fastpass-icon {
  height: 2.2em;
  position: absolute;
  top: -10px;
  left: -16px;
}

.lock-icon {
  height: 1.3em;
  position: relative;
  top: -3px;
}

/* mobile */
@media screen and (max-width: 1000px) {
  #cards-wrapper {
    grid-template-columns: repeat(auto-fit, minmax(calc(0.55 * 260px), 1fr));

    .card-wrapper {
      width: calc(0.55 * 260px);

      .card-button-container {
        margin-top: 5px;
      }
    }

    button {
      font-size: 12px;
      line-height: 18px;
    }
  }

  .fastpass-icon {
    height: 1.6em;
    top: -8px;
    left: -8px;
  }

  .lock-icon {
    height: 1.2em;
  }

  #buy-get-button-wrapper {
    text-shadow: 1px 1px black;
  }
}

.mr-icon {
  height: 20px;
  position: relative;
  top: -3px;
}

.fastpass-popover-icon {
  max-height: 20px;
}

/* desktop */
@media screen and (max-width: 1000px) {
  .mr-icon {
    height: 16px;
    position: relative;
    left: 1px;
    top: -2px;
  }
}

</style>
<style lang="scss">
#shop-info-popover > .popover{
  min-width: 450px;
  background: linear-gradient(0deg, #111324, #111324), #1E162F !important;
  border: 5px solid #00D1FF;
  box-shadow: 15px 15px 15px rgba(0, 0, 0, 0.4);
  border-radius: 25px;

  .popover-body{
    padding: 0.8rem 1rem;
  }
}
</style>
